import { createDevLogger } from 'chimera/all/plugins/devLogger'

/**
 * EventBus DevLogger instance
 * Uses the shared DevLogger utility for consistent logging
 */
const eventBusLogger = createDevLogger({
  name: 'EventBus',
  badgeColor: '#4CAF50',
  storageKeyPrefix: 'eventBus',
  defaultEnabled: false,
  windowDebugFlag: '__EVENTBUS_DEBUG__',
  windowExpandedFlag: '__EVENTBUS_EXPANDED__',
})

// Re-export with EventBus-specific names for backward compatibility
export const getEventBusLogging = eventBusLogger.getEnabled
export const setEventBusLogging = eventBusLogger.setEnabled
export const getEventBusLogsExpanded = eventBusLogger.getExpanded
export const setEventBusLogsExpanded = eventBusLogger.setExpanded

// Export logger instance for direct usage
export const logger = eventBusLogger
